import { notify } from '../../../components/Notifier';
import { usePlatform } from '../../../providers/PlatformProvider/PlatformProvider';
import { Settings } from '../../../providers/SettingsProvider/SettingsProvider';
import { fetchWithToken } from '../../../utils/api/api';
import { CLEVER_LOGIN_ERROR } from '../../../utils/error-messages';

interface UseCleverSignInProps {
  cleverLoginEnabled?: Settings['cleverLoginEnabled'];
}

export const useCleverSignIn = ({
  cleverLoginEnabled,
}: UseCleverSignInProps): (() => Promise<void>) => {
  const { track } = usePlatform();
  return async () => {
    if (!cleverLoginEnabled) {
      return;
    }

    try {
      const res = await fetchWithToken(`clever-login`);
      const data = await res.text();
      const url = new URL(data);

      window.location.assign(url.href);
    } catch (e) {
      notify.warning(CLEVER_LOGIN_ERROR);
      track('error-message-shown', { errorMessage: CLEVER_LOGIN_ERROR });
    }
  };
};

export default useCleverSignIn;
